export default {
  header: {
    title: 'Ótimo! Recebe o seguinte gratuitamente com a sua encomenda:',
    subtitle: 'Aplicaremos o desconto durante o processo de checkout.',
  },
  footer: {
    buttons: {
      no_thanks: 'Não, obrigado',
      add_to_basket: 'Adicionar ao carrinho',
    },
  },
};
